// src/components/RequireAuth.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn, setRedirectAfterLogin } from '../lib/session';

export default function RequireAuth({ children }) {
  const loc = useLocation();
  if (!isLoggedIn()) {
    const target = loc.pathname + loc.search + loc.hash;
    setRedirectAfterLogin(target);
    return (
      <Navigate
        to={`/register?redirectTo=${encodeURIComponent(target)}`}
        replace
      />
    );
  }
  return children;
}
